import React, {forwardRef, useCallback, useState} from "react";
import {Button, ButtonToolbar, Checkbox, DatePicker, Form, Input, Modal, SelectPicker, Stack} from 'rsuite';
import {addNewUserProject} from "../../../service/projectService";
import {projectModel} from "../../form/models";
import {
    descriptionPlaceholder,
    projectNamePlaceholder,
    responsibilitiesPlaceholder,
    technologiesPlaceholder
} from "../../constants/projectConstants";

// TODO look at moving these into constants, unclear if forwardRef can be used in multiple modals with no issue
const startDateInstance = forwardRef((props, ref) =>
    <DatePicker {...props} format="yyyy-MM" oneTap ranges={[]} style={{width: 200}} ref={ref}/>
);
const endDateInstance = forwardRef((props, ref) =>
    <DatePicker {...props} format="yyyy-MM" oneTap ranges={[]} style={{width: 200}} ref={ref}/>
);
const descriptionTextArea = forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);
const technologiesTextArea = forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);
const responsibilitiesTextArea = forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);

const AddProjectModal = (props) => {
    const { open, handleClose, userExperience, userId } = props;

    const [localState, setLocalState] = useState(
        {
            userId,
            isPresent: false,
            description: '',
            projectName: '',
            technologies: ''
        });

    const localClose = useCallback((response) => {
        handleClose(response);
        setLocalState({
            userId,
            isPresent: false,
            description: '',
            projectName: '',
            technologies: ''
        });
    }, [handleClose, userId]);

    const submitProjectAdd = (isFormValid) => {
        if(!isFormValid) return;
        addNewUserProject(localState).then((response) => {
            localClose(response);
        });
    };

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        if(event.isPresent === true) {
            event.endDate = new Date();
        }
        setLocalState({...localState, ...event});
    }

    return (
        <Modal
            open={open}
            onClose={localClose}
            size="lg"
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title>Add Project</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Stack direction='column' alignItems='flex-start'>
                    <p>Responsibilities should be written as a list: one line per item in the textarea.</p>
                    <p>Do not add bullets. Bullets will be added as part of resume preview/generation.</p>
                    <p>Technologies should be a comma separated list.</p>
                </Stack>
            </Modal.Body>
            <Form layout="vertical"
                  model={projectModel}
                  onChange={handleFormChange}
                  onSubmit={submitProjectAdd}
                  formValue={localState}
                  fluid
            >
                <Form.Group>
                    <Form.ControlLabel>Experience</Form.ControlLabel>
                    <Form.Control name="expId"
                                  accepter={SelectPicker}
                                  data={userExperience}/>
                    <Form.ControlLabel>Project Name</Form.ControlLabel>
                    <Form.Control
                        name="projectName"
                        placeholder={projectNamePlaceholder}
                    />
                    <Form.ControlLabel>Start Date</Form.ControlLabel>
                    <Form.Control name="startDate" accepter={startDateInstance} />
                    <Form.ControlLabel>EndDate</Form.ControlLabel>
                    <Form.Control
                        name="endDate"
                        accepter={endDateInstance}
                        disabled={localState.isPresent}
                    />
                    <Form.ControlLabel>Present</Form.ControlLabel>
                    <Form.Control name="isPresent"
                                  accepter={Checkbox}
                                  checked={localState.isPresent}
                                  value={!localState.isPresent}/>
                    <Form.ControlLabel>Project Description</Form.ControlLabel>
                    <Form.Control rows={2}
                                  name="description"
                                  accepter={descriptionTextArea}
                                  placeholder={descriptionPlaceholder}
                    />
                    <Form.ControlLabel>Project Technologies</Form.ControlLabel>
                    <Form.Control rows={2}
                                  name="technologies"
                                  accepter={technologiesTextArea}
                                  placeholder={technologiesPlaceholder}
                    />
                    <Form.ControlLabel>Responsibilities</Form.ControlLabel>
                    <Form.Control rows={10}
                                  name="responsibilities"
                                  accepter={responsibilitiesTextArea}
                                  placeholder={responsibilitiesPlaceholder}
                    />
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={localClose} appearance="default">
                            Cancel
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
}

export default AddProjectModal;